/* BlueTruck24 hub theme — homepage behaviour: brand tabs and FAQ accordion.
   Loaded (defer) by bt-home-brand-tabs and bt-home-faq; safe to include more than once.
   The contact form is handled by theme.js (data-bt-mailto-form), shared with /pages/contact.
   Everything is delegated from document, so it keeps working after a section re-render in the theme editor.
   State classes are read from data attributes written by the sections — no class names live in this file. */
(function () {
  'use strict';

  if (window.BT_HOME_READY) return;
  window.BT_HOME_READY = true;

  function $(selector, scope) {
    return (scope || document).querySelector(selector);
  }
  function $all(selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }
  function classList(el, attribute) {
    return (el.getAttribute(attribute) || '').split(' ').filter(Boolean);
  }
  function swap(el, add, remove) {
    if (!el) return;
    remove.forEach(function (name) { el.classList.remove(name); });
    add.forEach(function (name) { el.classList.add(name); });
  }

  // ── "Our Products" brand tabs: every panel is server-rendered, only `hidden` changes ──
  function selectTab(tab) {
    var scope = tab.closest('[data-bt-home-tabs]');
    if (!scope) return;
    var active = classList(scope, 'data-active-class');
    var idle = classList(scope, 'data-idle-class');
    var key = tab.getAttribute('data-bt-home-tab');
    $all('[data-bt-home-tab]', scope).forEach(function (button) {
      var on = button === tab;
      button.setAttribute('aria-pressed', String(on));
      swap(button, on ? active : idle, on ? idle : active);
    });
    $all('[data-bt-home-panel]', scope).forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-bt-home-panel') !== key;
    });
  }

  // ── FAQ accordion: one item open at a time, clicking the open one closes it ──
  function setFaqItem(scope, button, open) {
    var openClasses = classList(scope, 'data-open-class');
    var closedClasses = classList(scope, 'data-closed-class');
    var iconClasses = classList(scope, 'data-icon-open-class');
    button.setAttribute('aria-expanded', String(open));
    swap($('[data-bt-home-faq-answer]', button), open ? openClasses : closedClasses, open ? closedClasses : openClasses);
    swap($('[data-bt-home-faq-icon]', button), open ? iconClasses : [], open ? [] : iconClasses);
  }

  function toggleFaqItem(button) {
    var scope = button.closest('[data-bt-home-faq]');
    if (!scope) return;
    var open = button.getAttribute('aria-expanded') !== 'true';
    $all('[data-bt-home-faq-item]', scope).forEach(function (item) {
      setFaqItem(scope, item, item === button && open);
    });
  }

  document.addEventListener('click', function (event) {
    var tab = event.target.closest('[data-bt-home-tab]');
    if (tab) return selectTab(tab);
    var faqItem = event.target.closest('[data-bt-home-faq-item]');
    if (faqItem) toggleFaqItem(faqItem);
  });

  // ── Contact form: same as Hydrogen — open the mail client with the message, then show the address ──
})();
